<template>
  <!--右侧树形展示所有停车场，岗位，停车位-->
  <div class="trees">
    <el-input class="search" placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
    <el-tree
      ref="tree"
      :data="allDatas"
      :props="defaultProps"
      @node-click="handleTreeClick"
      node-key="id"
      :highlight-current="true"
      :show-checkbox="false"
      :default-expanded-keys="nodeKeys"
      :filter-node-method="filterNode"
    >
      <span slot-scope="{data}">
        <span v-if="data.type=='admin'">{{data.name}}</span>
        <span v-if="data.type=='group'">
          <span class="group-name-tip">集团</span>
          {{data.name}}
        </span>
        <span v-if="data.type=='property'">
          <span class="group-name-tip">物业</span>
          {{data.name}}
        </span>

        <span v-if="data.type=='parking'">
          <span class="group-name-tip" v-if="data.parkingType=='roadside'">道路</span>
          <span class="group-name-tip" v-if="data.parkingType=='onsite'">车场</span>
          {{data.name}}
        </span>
      </span>
    </el-tree>
  </div>
</template>
<script>
import { getScopeTree } from "@/api/url";
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      allDatas: [],
      filterText: "",
      nodeKeys: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
    };
  },
  props: {
    moduleName: String,
    areaId: String,
  },
  methods: {
    ...mapMutations(["setNodeData", "setNod", "getPage"]),
    //获取所有的停车场，岗位，停车位用于右侧树形展示
    getAllDatas: function () {
      var _this = this;
      this.$get(getScopeTree()).then((data) => {
        // if(data.status!=200) return;
        var type = data[0].type;
        if (this.moduleName === "space") {
          this.allDatas = data;
        } else if (this.moduleName === "group") {
          let tempArray = new Array();
          let temp = this.getDataByType("admin", data[0]);
          tempArray[0] = temp;
          this.allDatas = tempArray;
        } else if (this.moduleName === "property") {
          if (type == "property" || type == "parking") {
            this.allDatas = [];
            return;
          }
          let tempArray = new Array();
          let temp = this.getDataByType("group", data[0]);
          tempArray[0] = temp;
          this.allDatas = tempArray;
        } else if (this.moduleName === "parking") {
          if (type == "parking") {
            this.allDatas = [];
            return;
          }
          let tempArray = new Array();
          let temp = this.getDataByType("property", data[0]);
          tempArray[0] = temp;
          this.allDatas = tempArray;
        } else {
          let tempArray = new Array();
          let temp = this.getDataByType("parking", data[0]);
          tempArray[0] = temp;
          this.allDatas = tempArray;
        }
        console.log("this.allDatas");
        console.log(this.allDatas);
        this.allDatas.forEach(function (item) {
          _this.nodeKeys.push(item.id);
        });
      });
    },
    //点击树的节点展示相应数据
    handleTreeClick: function (node, data) {
      this.setNodeData(node);
      // this.setNod(data);
      this.getPage({
        curIndex: 1,
        rowsCount: 0,
      });
      this.$emit("handleTreeClick", node, data);
    },
    setCurrent(id) {
      this.$refs.tree.setCurrentKey(id);
    },
    getDataByType(type, data) {
      if (!data) {
        return;
      }
      if (data.type != type) {
        if (!Array.isArray(data.children)) {
          return data;
        } else {
          const children = data.children
            .map((ele) => {
              return this.getDataByType(type, ele);
            })
            .filter((ele) => ele !== null);
          return {
            type: data.type,
            name: data.name,
            id: data.id,
            parkingType: data.parkingType,
            children,
          };
        }
      } else {
        return {
          type: data.type,
          name: data.name,
          id: data.id,
          parkingType: data.parkingType,
        };
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
  },
  created() {
    console.log("852412");
  },
  mounted() {
    this.getAllDatas();
  },
  computed: {},
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
};
</script>
<style scoped>
/* @import "@/assets/css/areaTree.css"; */

.el-tree {
  color: #5c5c5c !important;
  overflow: auto;
  height: calc(100vh - 130px);
}
.is-current {
  background: #afc0e9 !important;
}
.trees {
  margin-bottom: 20px;
  border-right: 10px solid #eff2f7;
}
.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background: #ccc !important;
}

.isActive {
  background: #ccc !important;
}
.group-name-tip {
  color: red;
  font-size: 10px;
}
.search {
  border-radius: 10px !important;
  margin-bottom: 10px;
}

.parkClass {
  display: inline-block;
  height: 15px;
  line-height: 15px;
  /*background-color:#278cd8;*/
  background: url("~@/assets/images/park.png") no-repeat left center;
  padding-left: 20px;
  /*font-weight: bold;*/
  color: #606266;
  font-size: 14px;
}
.areaClass {
  display: inline-block;
  line-height: 15px;
  height: 15px;
  /*background-color:#278cd8;*/
  background: url("~@/assets/images/area.png") no-repeat left center;
  padding-left: 20px;
}
.spaceClass {
  display: inline-block;
  width: 10px;
  height: 10px;
  /*background-color:#278cd8;*/
  background: url("~@/assets/images/space.png") no-repeat center center;
}

.el-tree {
}

.trees {
  border-right: 10px solid #eff2f7;
  padding: 10px 5px 0 5px;
  box-sizing: border-box;
  height: 100%;
}
</style>